import { IOHelper, JSONHelper, WitnessModel } from '@neo-one/client-common';
import { BinaryReader, utils } from './utils';
export class Witness extends WitnessModel {
    constructor() {
        super(...arguments);
        this.equals = utils.equals(Witness, this, (other) => this.invocation.equals(other.invocation) && this.verification.equals(other.verification));
        this.toKeyString = utils.toKeyString(Witness, () => `${this.invocation.toString('hex')}:${this.verification.toString('hex')}`);
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfVarBytesLE(this.invocation) + IOHelper.sizeOfVarBytesLE(this.verification));
    }
    static deserializeWireBase({ reader }) {
        const invocation = reader.readVarBytesLE(utils.USHORT_MAX_NUMBER_PLUS_ONE);
        const verification = reader.readVarBytesLE(utils.USHORT_MAX_NUMBER_PLUS_ONE);
        return new this({ invocation, verification });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    static fromModel(witness) {
        return new this({ invocation: witness.invocation, verification: witness.verification });
    }
    get size() {
        return this.sizeInternal();
    }
    serializeJSON(_context) {
        return {
            invocation: JSONHelper.writeBuffer(this.invocation),
            verification: JSONHelper.writeBuffer(this.verification),
        };
    }
}

//# sourceMappingURL=Witness.js.map
